import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    codigoSolicitacaoDeAcesso: 0,
    codigoSolicitacaoDeVistoria: 0,
    codigoSolicCompart: 0,
    codigoSolicitacaoFiscalizacao: 0,
    codigoConsultaPrevia: 0
};

const analisesSlice = createSlice({
    name: "analises",
    initialState,
    reducers: {
        setCurrentSolicitacao: (state, action) => {
            state.codigoSolicitacaoDeAcesso = action.payload;

            return state;
        },

        setCurrentSolicitacaoVistoria: (state, action) => {
            state.codigoSolicitacaoDeVistoria = action.payload;

            return state;
        },

        setCurrentSolicitacaoComp: (state, action) => {
            state.codigoSolicCompart = action.payload;

            return state;
        },

        setCurrentSolicitacaoFiscalizacao: (state, action) => {
            state.codigoSolicitacaoFiscalizacao = action.payload;

            return state;
        },

        setCurrentConsultaPrevia: (state, action) => {
            state.codigoConsultaPrevia = action.payload;

            return state;
        },

        setCurrentAnaliseProjeto: (state, action) => {
            state.codigoAnaliseProjeto = action.payload;

            return state;
        }
    }
})

export const { setCurrentSolicitacao, setCurrentSolicitacaoVistoria, setCurrentSolicitacaoComp, setCurrentSolicitacaoFiscalizacao, setCurrentConsultaPrevia, setCurrentAnaliseProjeto } = analisesSlice.actions;
export default analisesSlice.reducer;